import type { ForfeitTurnAction } from "../types/action";
import type { ValidationResult } from "../types/common";
import type { HorrorRaceState } from "../types/game-state";
import { isFewPlayerVariant } from "../utils/player-count-rules";

export function validateForfeitTurn(
  state: HorrorRaceState,
  action: ForfeitTurnAction,
): ValidationResult {
  // Forfeit is a base mechanic available at any player count (official).
  if (state.phase !== "ROUND_DRAW_AND_PLACE") {
    return { valid: false, error: "Not in draw and place phase" };
  }

  // ≤5-player games draw twice per round; forfeit is only allowed on the 2nd
  // pass — the first pass must draw.
  if (
    isFewPlayerVariant(state.config.playerCount) &&
    (state.drawPass ?? 1) !== 2
  ) {
    return {
      valid: false,
      error: "Forfeit is only allowed on the second draw pass",
    };
  }

  const currentPlayerIndex = state.turnOrder[state.currentTurnIndex];
  const currentPlayer = state.players[currentPlayerIndex];

  if (action.playerId !== currentPlayer.id) {
    return { valid: false, error: "Not your turn" };
  }

  if (state.drawnCoins.length > 0) {
    return { valid: false, error: "Cannot forfeit after drawing coins" };
  }

  if (state.hasForfeitThisRound) {
    return { valid: false, error: "A player has already forfeited this round" };
  }

  if (state.coinPool.length === 0) {
    return { valid: false, error: "Cannot forfeit when pool is empty" };
  }

  return { valid: true };
}
